export default __webpack_public_path__ + "static/media/logo.6ac84323.png";